import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function NoMetaEditRightsInfoBox() {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        background: '#e6e7ea',
        borderRadius: '5px',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        height: '29px',
        px: '44px',
        width: 'fit-content',
      }}
    >
      <Typography variant="body1">
        {t('mediaPlanning.metaBooking.infoBoxes.noMetaEditRights.text')}
      </Typography>
    </Box>
  );
}
